import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import Common from './Common';
import Auth from './Auth';
import Movies from './Movies';
import Relations from './RelationManager';
import Critics from './CriticsManager';
import News from './NewsManager';
import Finance from './Finance';
import UserInfo from './userInfo';
import Artist from './Artist';
import Convert from './Convert';

export default history =>
  combineReducers({
    router: connectRouter(history),
    movies: Movies,
    common: Common,
    auth: Auth,
    relations: Relations,
    critics: Critics,
    news: News,
    finance: Finance,
    userInfo: UserInfo,
    artist: Artist,
    convert: Convert,
  });
